<template>
  <div class="login-bg">
    <div class="login-img">
      <img src="~@/assets/img/img_logo.svg" alt="正也直连管理后台" />
      <span>为商业流向直连设计</span>
      <img
        src="~@/assets/img/img_logo_p2ps2.svg"
        style="float:right;margin-top:15px;"
      />
    </div>
    <el-row type="flex" justify="space-around" class="bg-box">
      <el-col :span="16">
        <div class="login-box">
          <p class="login-title">流连宝账户登录</p>
          <div class="login-content">
            <el-form
              ref="loginForm"
              :model="loginForm"
              :rules="rules"
              class="login-form"
            >
              <ul>
                <li>
                  <el-form-item prop="code">
                    <el-input
                      v-model="loginForm.code"
                      placeholder="请输入企业代码"
                    >
                      <i class="el-icon-office-building icon" slot="prefix">
                      </i>
                    </el-input>
                  </el-form-item>
                </li>
                <li>
                  <el-form-item prop="username">
                    <el-input
                      v-model="loginForm.username"
                      placeholder="请输入账号"
                    >
                      <i class="el-icon-user icon" slot="prefix"> </i>
                    </el-input>
                  </el-form-item>
                </li>
                <li>
                  <el-form-item prop="password">
                    <el-input
                      v-model="loginForm.password"
                      type="password"
                      placeholder="请输入密码"
                    >
                      <i class="el-icon-lock icon" slot="prefix"> </i>
                    </el-input>
                  </el-form-item>
                </li>
                <li>
                  <el-form-item>
                    <el-button
                      type="primary"
                      :loading="isLoginLoading"
                      @click="onLogin('loginForm')"
                      class="Submit"
                      >{{ isLoginLoading ? "登录中" : "登录" }}
                    </el-button>
                  </el-form-item>
                </li>
              </ul>
            </el-form>
          </div>
        </div>
      </el-col>
    </el-row>
    <div
      class="page-footer"
      v-bind:class="{ collapsed: $store.state.collapsed }"
    >
      Copyright &copy;{{ currentYear }} by 上海正也信息科技有限公司
      <a href="https://beian.miit.gov.cn/" class="beian" target="_blank"
        >沪ICP备14016032号-6</a
      >
    </div>
  </div>
</template>

<script>
import { companyPwdLogin, companyLogin } from "@/api/index";

export default {
  name: "Login",
  beforeCreate() {
    this.currentYear = new Date().getFullYear();
  },
  data: () => ({
    isLoginLoading: false,
    loginForm: {
      code: "",
      username: "",
      password: ""
    },
    rules: {
      code: [{ required: true, message: "请输入企业代码", trigger: "blur" }],
      username: [{ required: true, message: "请输入账号", trigger: "blur" }],
      password: [
        { required: true, message: "请输入密码", trigger: "blur" }
        // {min: 6, max: 16, message: '长度在 6 到 16 个字符', trigger: 'blur'}
      ]
    }
  }),
  methods: {
    onLogin(formName) {
      this.$refs[formName].validate(async valid => {
        if (valid) {
          this.isLoginLoading = true;
          let values = { ...this[formName] };

          let res;

          let str = document.URL;

          // 企业人员登录
          let parameter = {
              username: values.username,
              password: values.password,
              company_code: values.code
            };
            res = await companyPwdLogin(parameter);
            if (0 === res.status) {
              this.$store.state.funcModuleArray =
                res.data.navigation.funcModuleArray || [];
              this.$store.state.isQiyeLogin = 1;

              this.$router.push({ name: "home" });
            } else {
              this.isLoginLoading = false;
              this.$message.error(res.msg);
            }


          // if (str.includes("qyllb") || str.includes("localhost")) {
          //   // 企业人员登录
          //   let parameter = {
          //     username: values.username,
          //     password: values.password,
          //     company_code: values.code
          //   };
          //   res = await companyPwdLogin(parameter);
          //   if (0 === res.status) {
          //     this.$store.state.funcModuleArray =
          //       res.data.navigation.funcModuleArray || [];
          //     this.$store.state.isQiyeLogin = 1;

          //     this.$router.push({ name: "home" });
          //   } else {
          //     this.isLoginLoading = false;
          //     this.$message.error(res.msg);
          //   }
          // } else if (str.includes("llb")) {
          //   // 正也人员登录
          //   // 正也都是扫码登录 这里应该不会进来
          //   let parameter = {
          //     company_admin_name: values.username,
          //     company_admin_password: values.password,
          //     company_code: values.code
          //   };
          //   res = await companyLogin(parameter);
          //   if (0 === res.status) {
          //     this.$store.state.isQiyeLogin = 0;
          //     this.$store.commit(
          //       "setFuncModuleArray",
          //       res.data.navigation.funcModuleArray || []
          //     );
          //     this.$router.push({ name: "home" });
          //   } else {
          //     this.isLoginLoading = false;
          //     this.$message.error(res.msg);
          //   }
          // }
        }
      });
    },
    keyupSubmit() {
      document.onkeydown = e => {
        let _key = window.event.keyCode;
        if (_key === 13) {
          this.onLogin("loginForm");
        }
      };
    }
  },
  mounted() {
    this.keyupSubmit();
  }
};
</script>

<style scoped lang="scss">
.login-bg {
  background: url("~@/assets/img/img_login_background.png");
  height: 100%;
  background-repeat: no-repeat;
  background-position: center;
  position: relative;
}

.login-bg .bg-box {
  height: 100%;
  margin-left: 0 !important;
  margin-right: 0 !important;
}

.login-bg .bg-box > div {
  position: relative;
  height: 100%;
  margin-left: 0 !important;
  margin-right: 0 !important;
}

.login-img {
  position: absolute;
  top: 0;
  width: 100%;
  padding: 15px 20px;
  box-sizing: border-box;

  img {
    vertical-align: middle;
  }
  span {
    display: inline-block;
    color: #fff;
    vertical-align: middle;
    margin: 5px 0 0 20px;
  }
}

.login-box {
  border-radius: 8px;
  position: absolute;
  top: 50%;
  margin-top: -230px;
  right: 0px;
  display: inline-block;
  background: #fff;

  .login-title {
    line-height: 68px;
    font-size: 22px;
    display: inline-block;
    border-bottom: 1px solid #e9e9e9;
    padding: 0 100px;
  }

  ul {
    padding: 30px 25px;

    .icon {
      height: 100%;
      width: 17px;
      text-align: center;
      line-height: 40px;
      margin-left: 4px;
    }

    .icon2 {
      width: 13px;
      margin-left: 6px;
    }

    .Submit {
      width: 100% !important;
      font-weight: 800;
      font-size: 16px;
      box-sizing: border-box;
      letter-spacing: 5px;
    }
  }

  ul li:last-child > div {
    margin-bottom: 0 !important;
  }
}

.login-form {
  .icon {
    font-size: 20px;
    color: #999a9b;
  }
}
.page-footer {
  position: fixed;
  bottom: 5px;
  left: 0;
  width: 100%;
  text-align: center;
  height: 16px;
  color: #fff;
  font-size: 11px;
  .beian {
    color: #fff;
  }
}
</style>
